import StoreScanner from '@/global/services/module-directory-scanner/store-scanner'

export default (new StoreScanner())
  .withoutEmptyFiles()
  .makeAllStoresNamespaced()
  .toFormatVuexUnderstands()
